module.exports = __webpack_public_path__ + "img/06.d7816134.jpg";